import { Plugin, PluginKey } from '@tiptap/pm/state'
import { Decoration, DecorationSet } from '@tiptap/pm/view'

const VARIABLE_REGEX = /%[A-Z0-9_]+%/gi

export const variableHighlightPlugin = new Plugin({
  key: new PluginKey('variableHighlight'),

  props: {
    decorations(state) {
      const { doc } = state
      const decorations: Decoration[] = []

      doc.descendants((node, pos) => {
        if (!node.isText || !node.text) return

        let match
        VARIABLE_REGEX.lastIndex = 0

        while ((match = VARIABLE_REGEX.exec(node.text)) !== null) {
          const start = pos + match.index
          const end = start + match[0].length

          decorations.push(
            Decoration.inline(start, end, {
              class: 'tiptap-variable',
            })
          )
        }
      })

      return DecorationSet.create(doc, decorations)
    },
  },
})
